import { render, staticRenderFns } from "./customFormActionBtn.vue?vue&type=template&id=027fcf46&scoped=true&"
import script from "./customFormActionBtn.vue?vue&type=script&lang=babel&"
export * from "./customFormActionBtn.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027fcf46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
